export default {
    resultadoBuscaTodosServicos: {
        filtros: {
            conteudo: {
                default: null,
                label: 'Pesquisa',
                value: ''
            },
            ativo: {
                default: null,
                type: 'ENUM',
                label: 'Situação',
                value: '',
                enum: {
                    ATIVO: 'Ativo',
                    INATIVO: 'Inativo',
                    AMBOS: 'Ambos'
                }
            },
        },
        paginacao: {
            page: 1,
            size: 10,
            sort: 'titulo',
            direction: 'ASC',
        }
    },
}